import React from 'react'
import { Link } from 'react-scroll'

export default function ScrollButton({destination, text, color}) {

  return (
    <Link
        to={destination}
        spy={true}
        smooth={true}
        duration={500}
        offset={-80}
        className={`${color} px-6 py-3 text-white rounded-xl max-w-fit mx-auto  hover:scale-110 hover:cursor-pointer active:scale-95`}
    >
        {text}
    </Link>
  )
}
